module.exports = __webpack_public_path__ + "static/aox_burgerbeteiligung_wohnen-57a1f1d08a8e6aff48307674516e41e4.png";